import React from 'react'
import intl from 'react-intl-universal';
import { Image, Card, message } from 'antd';
import { LeftOutlined, StarOutlined, ShareAltOutlined, PhoneOutlined, HistoryOutlined, StarFilled } from '@ant-design/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, {
    Navigation, Pagination, Scrollbar, A11y
} from 'swiper/core';
import PhoneChatDetail from '../../../component/PhoneChatDetail/PhoneChatDetail'

import GoogleMapReact from 'google-map-react';
import isEmpty from 'lodash.isempty';
import ChatModal from '../../../component/ChatModal/ChatModal'
import Nav from '../../../component/nav/nav'
import Banner from '../../../component/Banner/Banner'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import Foot from '../../../component/Foot/Foot'


import merchantsInfo from '../../../api/yellow'
import CHAT from '../../../api/chat'
import forum from '../../../api/bbs'

import { Loading } from 'antd-mobile'

// import wx from 'weixin-js-sdk'
// const ua = window.navigator.userAgent.toLowerCase()

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
const { Meta } = Card;

const getInfoWindowString = (shopcontent) => `
    <div>
      <div style="font-size: 16px;padding: 10px">
      邮箱/Email: ${shopcontent.email}
      </div>
      <div style="font-size: 14px;padding: 10px">
        <span style="color: grey;">
        电话/Phone: ${shopcontent.phone}
        </span>
      </div>
      <div style="font-size: 14px; color: grey;padding: 10px">
      地址/Address:  ${shopcontent.address}
      </div>
    </div>`;


const handleApiLoaded = (map, maps, places, shopcontent) => {
    const markers = [];
    const infowindows = [];

    places.forEach((place) => {
        markers.push(new maps.Marker({
            position: {
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng,
            },
            map,
        }));

        infowindows.push(new maps.InfoWindow({
            content: getInfoWindowString(shopcontent),
        }));
    });

    markers.forEach((marker, i) => {
        marker.addListener('click', () => {
            infowindows[i].open(map, marker);
        });
    });
};

export default class yellowPagesDetail extends React.Component {
    constructor() {
        super()
        this.state = {
            breadArrayData: [
                {
                    name: intl.get('KUNSHILANYISHOU'),
                    path: '/main',
                    navData: '1'
                },
                {
                    name: intl.get('SHNGAJIA'),
                    path: '/yellowpages',
                    navData: '2'
                }
            ],
            center: { lat: -27.4701621, lng: 153.0304155 },
            zoom: 17,
            places: [],
            shopcontent: {},
            shopImgs: [],
            products: [],
            peopleLikeData: [],
            modalVisible: false,
            shopUserData: {},
            messageDetailVisible: false,
            chatDetail: undefined

        }
    }

    componentDidMount() {
        this.getShopData()
    }


    // // 获取微信参数

    // getWeixinParms = async (shareItem) => {
    //     console.log('shareItem', shareItem)
    //     // if (ua.indexOf('micromessenger') < 0) {
    //     //     return false
    //     // }
    //     const weixinData = await forum.getSign({url: window.location.href.split('#')[0]})
    //     const weixinCurrent = await weixinData.json()
    //     console.log('weixinCurrent', weixinCurrent)

    //     wx.config({
    //         debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //         appId: 'wxc5cacf656994c6cc', // 必填，公众号的唯一标识
    //         timestamp: weixinCurrent.data.timestamp, // 必填，生成签名的时间戳
    //         nonceStr: weixinCurrent.data.noncestr, // 必填，生成签名的随机串
    //         signature: weixinCurrent.data.signature,// 必填，签名，见附录1
    //         jsApiList: [
    //           'updateAppMessageShareData',
    //           'updateTimelineShareData'
    //         ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    //       })

    //       wx.ready(() => {
    //         //分享给朋友
    //         wx.updateAppMessageShareData({
    //           title: shareItem.merchantsName, // 分享标题
    //           desc: shareItem.merchantsTypeName, // 分享描述
    //           link:window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //           imgUrl: shareItem.path ? shareItem.path.split(",")[0] : 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png', // 分享图标
    //           type: 'link', // 分享类型,music、video或link，不填默认为link
    //           dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    //           success: function () {
    //             // 用户确认分享后执行的回调函数
    //             console.log('121212', 11111111)
    //           },
    //           cancel: function () {
    //             // 用户取消分享后执行的回调函数
    //             console.log('取消', 22222222)

    //           }
    //         })

    //         //分享到朋友圈
    //         wx.updateTimelineShareData({
    //             title: shareItem.merchantsName, // 分享标题
    //           link:  window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //           imgUrl:  shareItem.path ? shareItem.path.split(",")[0] : 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png', // 分享图标
    //           success: function () {
    //             // 用户确认分享后执行的回调函数
    //           },
    //           cancel: function () {
    //             // 用户取消分享后执行的回调函数
    //           }
    //         })
    //       })



    // }


    getShopData = async () => {
        let breadArray = [{
            name: intl.get('KUNSHILANYISHOU'),
            path: '/main',
            navData: '1'
        },
        {
            name: intl.get('SHNGAJIA'),
            path: '/yellowpages',
            navData: '2'
        }]
        const { detailParms } = this.props.match.params
        sessionStorage['SHOPID'] = JSON.parse(detailParms)

        console.log(JSON.parse(detailParms))
        const parms = {
            merchantsInfoId: sessionStorage['SHOPID'],
            language: sessionStorage['language'],
            customerId: sessionStorage.getItem("USERDATA") ? JSON.parse(sessionStorage.getItem("USERDATA"))?.customer?.id : ''
        }
        let result = await merchantsInfo.merchantsInfoDetailWeb(parms)
        let result2 = await result.json()
        console.log('result2', result2)
        let data = result2.data[0]
        data.openTime = result2.data[0]?.openTime?.slice(0, 5)
        data.endTime = result2.data[0]?.endTime?.slice(0, 5)
        let pre = [
            {
                name: data.merchantsTypeName,
                path: '/yellowPageList',
                navData: '2'
            }, {
                name: data.merchantsName,
                path: '/yellowPagesDetail',
                navData: '2'
            }
        ]
        if (!data.address || data.address === '' || data.address === undefined || data.address === null) {
            data.address = '18 Selvage St,Sunnybank,Brisbane,Australia. QLD 4109'
        }
        merchantsInfo.getLocationByAddress(data.address).then(res => res.json())
            .then(result => {
                if (result.status === 'OK') {
                    this.setState({
                        center: result.results[0].geometry.location,
                        places: result.results,
                    })
                }

            })

        this.setState({
            shopcontent: data,
            shopImgs: data?.path ? data?.path.split(",") : [],
            products: result2.data[0].products.map((item, index) => {
                return {
                    path: item.path,
                    id: item.id,
                    merchantsId: item.merchantsId,
                    merchantsName: item.merchantsName,
                    productName: item.productName,
                    productDesc: item.productDesc
                }
            }),
            breadArrayData: [...breadArray, ...pre],

        }, () => {
            this.getPeopleLikeData()
            // this.getWeixinParms(this.state.shopcontent)
        })
    }

    getMapData = () => {

    }

    filterContext = () => {
        if (sessionStorage['language'] === '1') {
            return (<div className="yellow_page_detail_middle_bottom_list_left_content_item_right" dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context }}></div>)
        } else if (sessionStorage['language'] === '2') {
            return (<div className="yellow_page_detail_middle_bottom_list_left_content_item_right" dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context2 }}></div>)
        } else {
            return (<div className="yellow_page_detail_middle_bottom_list_left_content_item_right" dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context3 }}></div>)
        }
    }

    handleFilter = () => {
        this.props.history.push('/yellowPageList')
    }

    handleGoBack = () => {
        this.props.history.goBack()

    }

    getPeopleLikeData = () => {
        merchantsInfo.merchantsInfoListWeb({
            isHot: 1,
            language: sessionStorage['language'],
            pageSize: 4,
            pageNum: 1
        })
            .then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    this.setState({
                        peopleLikeData: result.data.list
                    })
                }
            })
    }

    goToDetail = (e) => {
        sessionStorage['SHOPID'] = e.id
        sessionStorage['MAINTYPE'] = e.firstCategory
        sessionStorage['SECONDTYPE'] = e.merchantsType
        this.setState({
            places: []
        }, () => {
            this.getShopData()
        })
    }

    judgeCollect = () => {
        console.log('val', this.state.shopcontent.collectFlag)
        if (this.state.shopcontent.collectFlag === 0) {
            return (
                <div className="yellow_page_detail_top_right_item" onClick={this.handleCollect}>
                    <div className="yellow_page_detail_top_right_item_icon1"></div>
                    <div className="yellow_page_detail_top_right_item_name customer_hover">{intl.get('SHOUCAGN')}</div>
                </div>
            )
        } else {
            return (
                <div className="yellow_page_detail_top_right_item" onClick={this.handleUncollect}>
                    <div className="yellow_page_detail_top_right_item_icon3"></div>
                    <div className="yellow_page_detail_top_right_item_name customer_hover">{intl.get('YISHOUCANG')}</div>
                </div>
            )
        }
    }

    handleCollect = () => {
        if (!sessionStorage.getItem("USERDATA")) {
            message.warning(intl.get('QINGXIANDENGLU'))
            return false
        }
        let userid = ''
        let token = ''
        if (sessionStorage.getItem("USERDATA")) {
            userid = JSON.parse(sessionStorage.getItem("USERDATA")).customer.id
            token = JSON.parse(sessionStorage.getItem("USERDATA")).token
        }
        let parms = {
            customerId: userid,
            merchantsId: sessionStorage['SHOPID']
        }
        merchantsInfo.addMerchantsCollect(parms, token)
            .then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    this.getShopData()
                    message.success(intl.get('SHOUCHENGCHANEG'))
                }
            })
    }

    handleUncollect = () => {
        if (!sessionStorage.getItem("USERDATA")) {
            message.warning(intl.get('QINGXIANDENGLU'))

            return false
        }
        let userid = ''
        let token = ''
        if (sessionStorage.getItem("USERDATA")) {
            userid = JSON.parse(sessionStorage.getItem("USERDATA")).customer.id
            token = JSON.parse(sessionStorage.getItem("USERDATA")).token
        }
        let parms = {
            customerId: userid,
            merchantsId: sessionStorage['SHOPID']
        }
        merchantsInfo.cancelMerchantsCollect(parms, token)
            .then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    this.getShopData()
                    message.success(intl.get('QUXIAOHSHOU'))
                }
            })
    }


    // 移动端


    handlePhoneReply = () => {
        let arr = []
        for (let i in this.state.phoneListData) {
            if (!this.state.phoneListData[i].replyId) {
                arr.push(this.state.phoneListData[i])
            }
        }

        for (let i in this.state.phoneListData) {
            for (let j in arr) {
                arr[j].children = []
                if (this.state.phoneListData[i].replyId === arr[j].id) {
                    arr[j].children.push(this.state.phoneListData[i])
                }
            }
        }
        console.log('arr', arr)
        this.setState({
            phoneReplyList: arr
        })
    }

    getPhoneData = (e) => {
        this.setState({
            phoneReplyData: e
        })
    }

    InfiniteScrollContent = () => {
        return (
            <>
                {this.state.hasMore ? (
                    <>
                        <span>Loading</span>
                        <Loading />
                    </>
                ) : (
                    <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
                )}
            </>
        )
    }

    loadMore = async () => {

        // let res = await forum.topicDetail(
        //     {
        //         topicId: sessionStorage['BBSTOPICID'],
        //         customerId: JSON.parse(sessionStorage.getItem("USERDATA"))
        //             ? JSON.parse(sessionStorage.getItem("USERDATA")).customer.id
        //             : "",
        //         language: sessionStorage["language"],
        //         pageSize: this.state.pageSize,
        //         pageNum: this.state.pageNum,
        //     }
        // )
        // let result = await res.json()
        // console.log('1212', 1212)
        // let arr = []
        // arr = this.state.phoneListData
        // if (result.ret === 200 && (this.state.pageNum * this.state.pageSize) < result.data.totalCount) {
        //     this.setState({
        //         pageNum: this.state.pageNum + 1,
        //         totalCount: result.data.totalCount,
        //         phoneListData: [...arr, ...result.data.list],
        //     }, () => {
        //         this.handlePhoneReply()
        //     });
        // } else {
        //     this.setState({
        //         hasMore: false
        //     })
        // }

    }

    filterPhoneContext = () => {
        if (sessionStorage['language'] === '1') {
            return (<div dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context }}></div>)
        } else if (sessionStorage['language'] === '2') {
            return (<div dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context2 }}></div>)
        } else {
            return (<div dangerouslySetInnerHTML={{ __html: this.state.shopcontent.context3 }}></div>)
        }
    }

    judgePhoneCollect = () => {
        if (this.state.shopcontent.collectFlag === 0) {
            return (
                <StarOutlined style={{ fontSize: '1.5rem', fontWeight: '700' }} onClick={this.handleCollect} />


            )
        } else {
            return (
                <StarFilled style={{ fontSize: '1.5rem', fontWeight: '700' }} onClick={this.handleUncollect} />
            )
        }
    }

    cancelModal = () => {
        this.setState({
            modalVisible: false
        })
    }

    // 此事件接收子对象
    childEvevnt = childDate => {
        this.$child = childDate;
    };

    pcChildEvevnt = childDate => {
        console.log('1212', childDate)
        this.$pcchild = childDate;
    };

    handleChat = () => {
        if (JSON.parse(sessionStorage.getItem("USERDATA"))?.customer?.isMerchants !== 0) {
            message.warning(intl.get('QINGSHIYONGPUTONGKEHULIANXISHANGJIA'))
        }
        merchantsInfo.customerList({
            merchantsId: sessionStorage['SHOPID'],
        }, JSON.parse(sessionStorage.getItem("USERDATA"))?.token)
            .then(res => res.json())
            .then(result => {
                console.log('result', result)
                if (result.ret === 200 && result.data.list.length !== 0) {
                    this.setState({
                        modalVisible: true,
                        shopUserData: result.data.list[0]
                    }, () => {
                        this.$pcchild.sendChild()
                    })
                } else {
                    message.warning(intl.get('ZANGSHIMEIYOUKEHU'))
                }

            })
    }




    detailChatVisible = () => {

        if (JSON.parse(sessionStorage.getItem("USERDATA"))?.customer?.isMerchants !== 0) {
            message.warning(intl.get('QINGSHIYONGPUTONGKEHULIANXISHANGJIA'))
            return false
        }
        merchantsInfo.customerList({
            merchantsId: sessionStorage['SHOPID'],
        }, JSON.parse(sessionStorage.getItem("USERDATA"))?.token)
            .then(res => res.json())
            .then(result => {
                console.log('result', result)
                if (result.ret === 200 && result.data.list.length !== 0) {
                    this.setState({
                        shopUserData: result.data.list[0]
                    }, () => {
                        this.phoneChat()
                    })
                } else {
                    message.warning(intl.get('ZANGSHIMEIYOUKEHU'))
                }

            })
    }


    phoneChat = () => {
        CHAT.queryFrame({
            memberId: JSON.parse(sessionStorage.getItem("USERDATA"))?.customer.id,
        }, JSON.parse(sessionStorage.getItem("USERDATA"))?.token).then(res => res.json())
            .then(result => {
                console.log('result121212=======>', result)
                if (result.ret === 200 && result.data.content.length !== 0) {
                    this.setState({
                        chatDetail: result.data.content[0],
                        messageDetailVisible: true,
                    }, () => {
                        this.$child.sendChild()
                    })
                } else {
                    this.setState({
                        chatDetail: {
                            chatRecords: []
                        },
                        messageDetailVisible: true,

                    }, () => {
                        this.$child.sendChild()
                    })
                }
            })
    }



    getClose = () => {
        this.setState({
            messageDetailVisible: false
        })
    }

    handleGotoMain = () => {
        this.props.history.push({ pathname: '/main' })
    }

    gotoOutSide = (url) => {
        console.log('url', url)
        if (url !== '') {
            let str = url.substring(0, 4)
            console.log('str', str)
            if (str === 'http') {
                window.location.href = url

            } else {
                window.location.href = 'http://' + url

            }
        }
    }

    handleGotoPage = (val) => {
        switch (val) {
            case 1:
                this.props.history.push({ pathname: '/yellowpages' })
                break
            case 2:
                this.props.history.push({ pathname: '/bbspages' })
                break
            default:
                break
        }
    }



    render() {
        const { places, shopcontent } = this.state
        document.title = this.state.shopcontent.merchantsName;
        document.querySelector('meta[property="og:title"]').setAttribute('content', this.state.shopcontent.merchantsName);
        document.querySelector('meta[property="og:description"]').setAttribute('content', this.state.shopcontent.merchantsName);
        document.querySelector('meta[itemprop="description"]').setAttribute('content', this.state.shopcontent.merchantsName);
        document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
        document.querySelector('meta[property="og:image"]').setAttribute('content', this.state.shopcontent.path ? this.state.shopcontent.path.split(",")[0] : 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="image"]').setAttribute('content', this.state.shopcontent.path ? this.state.shopcontent.path.split(",")[0] : 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="name"]').setAttribute('content', this.state.shopcontent.merchantsName);
        return (
            <>
                <div className="main_content">
                    <Nav history={this.props.history} props={this.props} />
                    <Banner type="1" history={this.props.history} setBannerSearch={this.handleFilter} />
                    <div className="yellow_page">
                        <BreadCrumb history={this.props.history} breadData={this.state.breadArrayData} style={{ paddingBottom: '0' }} />
                        <div className="yellow_page_detail">

                            <div className="yellow_page_detail_top">
                                <div className="yellow_page_detail_top_left">
                                    <div className="yellow_page_detail_top_left_title">{this.state.shopcontent.merchantsName}</div>
                                    <div className="yellow_page_detail_top_left_createtime">{this.state.shopcontent.createDate}{intl.get('GEGNXINGUO')}</div>
                                    <div className="yellow_page_detail_top_left_bottom">
                                        <div className="yellow_page_detail_top_left_bottom_item">{this.state.shopcontent.clickNum ? this.state.shopcontent.clickNum : 0}{intl.get('CILIULAN')}</div>
                                        <div className="yellow_page_detail_top_left_bottom_item"><span className="yellow_page_detail_top_left_bottom_item_icon"></span>{this.state.shopcontent.week}</div>
                                        <div className="yellow_page_detail_top_left_bottom_item"><span className="yellow_page_detail_top_left_bottom_item_icon2"></span>{this.state.shopcontent.openTime}-{this.state.shopcontent.endTime}</div>
                                    </div>
                                </div>


                                <div className="yellow_page_detail_top_right">
                                    {
                                        this.judgeCollect()
                                    }

                                    <div className="yellow_page_detail_top_right_item"  >
                                        <div className="yellow_page_detail_top_right_item_icon2"></div>
                                        <div className="yellow_page_detail_top_right_item_name">{intl.get('FENXIANG')}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="yellow_page_detail_middle">
                                <div className="yellow_page_detail_middle_content">
                                    <div className="yellow_page_detail_middle_content_left">
                                        <div className="yellow_page_detail_middle_content_left_img">
                                            <div className="yellow_page_detail_middle_content_left_img_main">
                                                <Image
                                                    width='3.24rem'
                                                    height='2.76rem'
                                                    preview={false}
                                                    src={this.state.shopcontent.path ? this.state.shopcontent.path.split(",")[0] : ''}
                                                    fallback="data:image/png;base64,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"

                                                />
                                            </div>
                                            <div className="yellow_page_detail_middle_content_left_img_second">
                                                <Swiper
                                                    spaceBetween={0}
                                                    slidesPerView={this.state.shopImgs.length < 3 ? this.state.shopImgs.length : 3}
                                                    loop={true}
                                                    navigation={true}
                                                >

                                                    {
                                                        this.state.shopImgs.map((item, index) => {
                                                            return (
                                                                <SwiperSlide key={index}>
                                                                    <Image
                                                                        width={'1.02rem'}
                                                                        height={'0.65rem'}
                                                                        src={item}
                                                                        preview={true}
                                                                    />
                                                                </SwiperSlide>
                                                            )
                                                        })
                                                    }
                                                </Swiper>

                                            </div>

                                        </div>
                                        <div className="yellow_page_detail_middle_content_left_contnet">
                                            <div className="yellow_page_detail_middle_content_left_contnet_type">{intl.get('LEIXING')}： {this.state.shopcontent.firstCategoryName}</div>
                                            <div className="yellow_page_detail_middle_content_left_contnet_region">{intl.get('SHUSUODIQU')}： {this.state.shopcontent.regionName}</div>
                                            <div className="yellow_page_detail_middle_content_left_contnet_connectpeople">
                                                {/* <div className="yellow_page_detail_middle_content_left_contnet_connectpeople_name">{intl.get('LIANXIREN')}： {this.state.regionName}</div> */}
                                                <div className="yellow_page_detail_middle_content_left_contnet_connectpeople_icon" onClick={this.handleChat}>
                                                    <div className="yellow_page_detail_middle_content_left_contnet_connectpeople_icon_img">
                                                        <div className="yellow_page_detail_middle_content_left_contnet_connectpeople_icon_img_icons"></div>
                                                    </div>
                                                    <div className="yellow_page_detail_middle_content_left_contnet_connectpeople_icon_text">{intl.get('ZAIXIANLIANXISHANGJAI')}</div>
                                                </div>
                                                <ChatModal modalVisible={this.state.modalVisible} modalsuccess={this.cancelModal} modalCancel={this.cancelModal} props={this.props} chatObject={this.state.shopcontent} shopUserData={this.state.shopUserData} pcChildEvevnt={this.pcChildEvevnt} />
                                            </div>
                                            <div className="yellow_page_detail_middle_content_left_contnet_mail">{intl.get('DIANPUYOUXIANG')}：{this.state.shopcontent.email}</div>
                                            <div className="yellow_page_detail_middle_content_left_contnet_address">{intl.get('DIANPUWANGZHI')}： {this.state.shopcontent.webAddress}</div>
                                            <div className="yellow_page_list_left_item_msg_box">
                                                <div className="yellow_page_list_left_item_msg_box_item">
                                                    {this.state.shopcontent.tags}
                                                </div>

                                            </div>
                                            <div className="yellow_page_detail_middle_content_left_contnet_phone">
                                                <div className="yellow_page_detail_middle_content_left_contnet_phone_icon"></div>
                                                <div className="yellow_page_detail_middle_content_left_contnet_phone_number">{this.state.shopcontent.phone}</div>

                                            </div>


                                        </div>
                                    </div>
                                    <div className="yellow_page_detail_middle_content_right">
                                        <Card
                                            hoverable={false}
                                            bordered={false}
                                            style={{
                                                width: '2.86rem', filter: 'drop-shadow(0px 4px 16px rgba(0, 0, 0, 0.12))', borderRadius: '10px'
                                            }}
                                            bodyStyle={{ background: '#fff', color: '#ffffff', borderRadius: ' 0 0 10px 10px', padding: '0.24rem' }}
                                            cover={

                                                <div className="yellow_page_detail_middle_content_right_map">
                                                    {
                                                        !isEmpty(places) && (<GoogleMapReact
                                                            bootstrapURLKeys={{ key: 'AIzaSyB37jXlk9_-rcuRxc5YBB3qmLeKCl70UGU' }}
                                                            defaultCenter={this.state.center}
                                                            defaultZoom={this.state.zoom}
                                                            yesIWantToUseGoogleMapApiInternals
                                                            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps, places, shopcontent)}
                                                        >
                                                        </GoogleMapReact>)
                                                    }
                                                </div>
                                            }>
                                            <Meta title={
                                                <div className="yellow_page_detail_middle_content_right_map_title">
                                                    <span className="yellow_page_detail_middle_content_right_map_icon"></span>
                                                    <div className="yellow_page_detail_middle_content_right_map_address">{this.state.shopcontent.address}</div>
                                                </div>
                                            } />
                                        </Card>
                                    </div>

                                </div>
                            </div>
                            <div className="yellow_page_detail_middle_bottom_title">
                                <div className="yellow_page_detail_middle_bottom_title_item">{intl.get('WIELETIXINGNI')}</div>
                                <div className="yellow_page_detail_middle_bottom_title_item">
                                    <div className="yellow_page_detail_middle_bottom_title_item_icon"></div>
                                    <div className="yellow_page_detail_middle_bottom_title_item_name">
                                        {intl.get('YIWEIJIEDAN')}
                                    </div>

                                </div>

                            </div>

                            <div className="yellow_page_detail_middle_bottom_content">

                                <div className="yellow_page_detail_middle_bottom_content_item">
                                    <div className="yellow_page_detail_middle_bottom_content_item_icon"></div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_title"> {intl.get('XIANSHANGGOUTONG')}</div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_content">{intl.get('YIYONGHU')}</div>
                                </div>

                                <div className="yellow_page_detail_middle_bottom_content_item">
                                    <div className="yellow_page_detail_middle_bottom_content_item_icon"></div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_title">{intl.get('XIANXIAFUWU')}</div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_content">{intl.get('YUSHANGJIAGOUTONG')}</div>

                                </div>

                                <div className="yellow_page_detail_middle_bottom_content_item">
                                    <div className="yellow_page_detail_middle_bottom_content_item_icon"></div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_title">{intl.get('FUWUSOUHOU')}</div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_content">{intl.get('YOUBAOZHANGQID')}</div>

                                </div>

                                <div className="yellow_page_detail_middle_bottom_content_item">
                                    <div className="yellow_page_detail_middle_bottom_content_item_icon"></div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_title">{intl.get('ZAIXIANKEHU')}</div>
                                    <div className="yellow_page_detail_middle_bottom_content_item_content">{intl.get('ZAIXIANKEFU')}</div>

                                </div>
                            </div>
                        </div>

                        <div className="yellow_page_detail_middle_bottom_list">
                            <div className="yellow_page_detail_middle_bottom_list_left">
                                <div className="yellow_page_detail_middle_bottom_list_left_title">
                                    <div className="yellow_page_detail_middle_bottom_list_left_title_item_active">{intl.get('FUWUMIAOSHU')}</div>
                                    <div className="yellow_page_detail_middle_bottom_list_left_title_item">{intl.get('XIANGGUANGTUIJIAN')}</div>
                                </div>
                                <div className="yellow_page_detail_middle_bottom_list_left_content">
                                    <div className="yellow_page_detail_middle_bottom_list_left_content_item">
                                        <div className="yellow_page_detail_middle_bottom_list_left_content_item_left">
                                            <div className="yellow_page_detail_middle_bottom_list_left_content_item_left_icon"></div>
                                            <div className="yellow_page_detail_middle_bottom_list_left_content_item_left_title">{intl.get('FUWUMIAOSHU')}</div>

                                        </div>

                                        {
                                            this.filterContext()
                                        }


                                    </div>


                                    <div className="yellow_page_detail_middle_bottom_list_left_content_item">
                                        <div className="yellow_page_detail_middle_bottom_list_left_content_item_left">
                                            <div className="yellow_page_detail_middle_bottom_list_left_content_item_left_icon2"></div>
                                            <div className="yellow_page_detail_middle_bottom_list_left_content_item_left_title">{intl.get('XIANGGUANGTUIJIAN')}</div>

                                        </div>
                                        <div className="yellow_page_detail_middle_bottom_list_left_content_item_right2">
                                            <div className="yellow_page_detail_middle_bottom_list_left_content_item_right_item">
                                                <Swiper
                                                    spaceBetween={0}
                                                    slidesPerView={this.state.products.length < 4 ? this.state.products.length : 4}
                                                    loop={true}
                                                    navigation={false}
                                                >

                                                    {

                                                        this.state.products.map((item, index) => {
                                                            return (
                                                                <SwiperSlide key={index}>
                                                                    <div className="yellow_page_detail_middle_bottom_list_left_content_item_right_item_img">
                                                                        <Image
                                                                            width={'1.42rem'}
                                                                            height={'1.17rem'}
                                                                            src={item.path ? item.path : ''}
                                                                            preview={true}
                                                                        />
                                                                    </div>
                                                                    <div className="yellow_page_detail_middle_bottom_list_left_content_item_right_item_title">{item.productName}</div>
                                                                    <div className="yellow_page_detail_middle_bottom_list_left_content_item_right_item_tags"><span className="yellow_page_detail_middle_bottom_list_left_content_item_right_item_tags_text">{item.productDesc}</span></div>
                                                                </SwiperSlide>
                                                            )
                                                        })
                                                    }

                                                </Swiper>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="yellow_page_detail_middle_bottom_list_right">
                                <div className="yellow_page_detail_middle_bottom_list_right_title">
                                    <div className="yellow_page_detail_middle_bottom_list_right_title_item">{intl.get('CAINIXIHUAN')}</div>
                                </div>

                                <div className="yellow_page_detail_middle_bottom_list_right_content">
                                    {
                                        this.state.peopleLikeData.map((item) => {
                                            return (
                                                <div className="yellow_page_detail_middle_bottom_list_right_content_item" key={item.id} onClick={this.goToDetail.bind(this, item)}>
                                                    <div className="yellow_page_detail_middle_bottom_list_right_content_item_img">
                                                        <Image
                                                            src={item.path ? item.path.split(",")[0] : ''}
                                                            fallback="data:image/png;base64,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"
                                                            preview={true}
                                                        />
                                                    </div>
                                                    <div className="yellow_page_detail_middle_bottom_list_right_content_item_title">
                                                        {item.merchantsName}
                                                    </div>
                                                    <div className="yellow_page_detail_middle_bottom_list_right_content_item_desc">{item.tags}</div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </div>
                        </div>

                    </div>

                    <Foot history={this.props.history} />

                </div>

                {/* 移动端=========================================================================================================================================================================================================================================================================== */}

                <div className="phone_content bbs_phone_content">
                    <div className="phone_bbs_index_top">
                        <div className="phone_bbs_index_top_first">
                            <div className="phone_bbs_index_top_first_left">
                                <div className="phone_bbs_index_top_first_left_img"></div>
                                <span className="phone_bbs_index_top_first_left_text">{intl.get('YISHOULUNT')} {intl.get('FUWUYUAOZHOU')}</span>
                            </div>
                            <div className="phone_bbs_index_top_first_right" onClick={this.handleGotoMain}></div>
                        </div>
                        <div className="phone_bbs_index_top_detail">
                            <div className="phone_bbs_index_top_detail_item">
                                <LeftOutlined onClick={this.handleGoBack} />
                            </div>
                            <div className="phone_bbs_index_top_detail_item">{intl.get('SHANGJIAXIANGIQNG')} </div>
                            <div className="phone_bbs_index_top_detail_item">
                                <a href={'tel:' + this.state.shopcontent.phone}> <PhoneOutlined style={{ fontSize: '1.5rem', fontWeight: '700', color: "#000000" }} /></a>
                                {
                                    this.judgePhoneCollect()
                                }
                                <ShareAltOutlined style={{ fontSize: '1.5rem', fontWeight: '700' }} />
                            </div>
                        </div>
                        <div className='phone_yellow_buttons'>
                            <div className='phone_yellow_buttons_item' onClick={this.handleGotoPage.bind(this,1)}>{intl.get('SHANGJIAHUANG')}</div>
                            <div className='phone_yellow_buttons_item' onClick={this.handleGotoPage.bind(this,2)}>{intl.get('YISHOULUNT')}</div>
                        </div>

                    </div>

                    <div className="phone_bbs_detail_context">
                        <div className="phone_shop_content_item_top">
                            <div className="phone_shop_content_item_top_name">{this.state.shopcontent.merchantsName}</div>
                            <div className="phone_shop_content_item_top_time">{this.state.shopcontent.openTime} - {this.state.shopcontent.endTime}   {this.state.shopcontent.week}</div>
                            <div className="phone_shop_content_item_top_tag">{this.state.shopcontent.tags}  </div>

                            <div className="phone_shop_content_item_top_connect"> {intl.get('LIANXIXIN')}</div>

                            <div className="phone_shop_content_item_top_connect_item">
                                <HistoryOutlined />  {intl.get('KAIDIANSHIJIAN')}： {this.state.shopcontent.openTime} - {this.state.shopcontent.endTime}
                            </div>


                            <div className="phone_shop_content_item_top_connect_item">
                                <HistoryOutlined />  {intl.get('LIANXIDIANHUA')}：  <a href={'tel:' + this.state.shopcontent.phone}>{this.state.shopcontent.phone}</a>
                            </div>



                            <div className="phone_shop_content_item_top_connect_item">
                                <HistoryOutlined />{intl.get('DIZHI')}： {this.state.shopcontent.address}
                            </div>



                            <div className="phone_shop_content_item_top_connect_item" onClick={this.gotoOutSide.bind(this, this.state.shopcontent.webAddress)}>
                                {/* eslint-disable-next-line react/jsx-no-duplicate-props */}
                                <HistoryOutlined />  {intl.get('DIANPUWANGZHI')}： <span style={{ color: '#1890ff' }}>
                                    {this.state.shopcontent.webAddress}

                                </span>

                            </div>
                        </div>

                        <div className="phone_shop_content_item_top_connect_map">
                            {
                                !isEmpty(places) && (<GoogleMapReact
                                    bootstrapURLKeys={{ key: 'AIzaSyB37jXlk9_-rcuRxc5YBB3qmLeKCl70UGU' }}
                                    defaultCenter={this.state.center}
                                    defaultZoom={this.state.zoom}
                                    yesIWantToUseGoogleMapApiInternals
                                    onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps, places, shopcontent)}
                                >
                                </GoogleMapReact>)
                            }
                        </div>
                        <div className="phone_shop_content_item_top_connect">{intl.get('DIANPUTUPIAN')}</div>

                        <div className="phone_shop_content_item_top_connect_imgs">
                            {
                                this.state.shopcontent?.path?.split(",").map((item2, index2) => {
                                    return (
                                        <div className="phone_shop_content_item_imgs_item" key={index2}>
                                            <Image
                                                width='100px'
                                                preview={true}
                                                src={item2}
                                                fallback="data:image/png;base64,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"
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className="phone_bbs_detail_context_item">
                            <div className="phone_shop_content_item_top_connect">{intl.get('XIANGQINGMIAOSHU')}</div>

                            {
                                this.filterPhoneContext()
                            }

                            <div className="phone_content_item_imgs">

                            </div>
                        </div>


                    </div>

                    <div className="phone_bbs_detail_buttom">
                        <div className="phone_bbs_detail_buttom_btn" onClick={this.detailChatVisible}>
                            {intl.get('ZAIXIANLIANXISHANGJAI')}
                        </div>
                    </div>
                    <PhoneChatDetail messageDetailVisible={this.state.messageDetailVisible} chatDetail={this.state.chatDetail} childEvevnt={this.childEvevnt} closeDetail={this.getClose} shopUserData={this.state.shopUserData} />


                </div>
            </>
        )
    }
}